import { LegacyIIQApi } from '../legacy-iiq-api'
import { SyncAipReq } from '@harvestiq/iiq/common'

export const syncAip =
  ({ legacyIIQApi }: { legacyIIQApi: LegacyIIQApi }) =>
  (body: SyncAipReq) =>
    legacyIIQApi.post('/aip-events/sync', body)
